<template>
  <v-container class="container--max">
    <slot name="ad-leaderboard">
      <ad-leaderboard></ad-leaderboard>
    </slot>
    <v-row justify="center" class="my-4">
      <!-- left -->
      <v-col cols="12" sm="11" md="11" lg="11">

        <slot name="main"></slot>

        <v-list two-line v-for="(item, i) in items" :key="i" class="mb-6">
          <v-list-item>
            <v-list-item-avatar size="72">
              <v-img :src="item.image"></v-img>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="text-h5" v-html="item.name"></v-list-item-title>
              <v-list-item-subtitle class="subtitle-1 grey--text text--darken-1" v-html="item.position"></v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action v-if="item.link" class="d-none d-sm-inline-flex" >
              <v-btn color="primary" text :href="item.link">View Articles</v-btn>
            </v-list-item-action>
<!--             <v-list-item-action v-if="item.link" class="d-inline-flex d-sm-none" >
              <v-btn color="primary" icon :href="item.link">
                <v-icon>mdi-arrow-right</v-icon>
              </v-btn>
            </v-list-item-action> -->
            <v-list-item-action v-if="item.twitter" class="d-none d-sm-inline-flex">
              <v-btn color="light-blue accent-3" icon :href="'https://twitter.com/' + item.twitter" target="_blank" rel="noopener"><v-icon>mdi-twitter</v-icon></v-btn>
            </v-list-item-action>
          </v-list-item>
          <v-card flat>
            <v-card-text v-html="item.text"></v-card-text>
          </v-card>
        </v-list>

        <p>ConservativeHome is part of <a href="https://www.totalpolitics.com/" target="_blank" rel="noopener">Total Politics Group</a></p>

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'AppPageWhoWeAre',

    data: () => ({
      items: [
        { 
          name: 'Angus Parsad-Wyatt', 
          position: 'Director of Political Engagement, Total Politics', 
          text: 'Angus Parsad-Wyatt joined ConservativeHome as Commercial Director in September 2021, and was appointed Chief Executive in January 2023. He is now Director of Political Engagement for our parent company, Total Politics, and oversees ConservativeHome. Prior to joining ConservativeHome, Angus held commercial roles at the CBI and Channel 4.', 
          link: false, 
          twitter: 'anguswyatt', 
          image: 'https://conservativehome.com/wp-content/uploads/2022/06/angus-parsad-wyatt-square.jpg' 
        },
        { 
          name: 'Giles Dilnot',
          position: 'Editor',
          text: 'Giles Dilnot was appointed Editor of ConservativeHome in August 2024. He was previously a journalist and presenter at the BBC - including working on the Daily Politics show; the Director of Communications at the Legatum Institute and the Office of the Children’s Commissioner; and a Special Advisor to the Foreign Secretary and Home Secretary.', 
          link: '/author/giles-dilnot/',
          twitter: 'reporterboy',
          image: 'https://conservativehome.com/wp-content/uploads/2024/09/cropped-WhatsApp-Image-2024-09-11-at-10.15.28-1.jpeg' 
        },
        { 
          name: 'Henry Hill', 
          position: 'Deputy Editor', 
          text: 'Henry Hill is Deputy Editor of ConservativeHome. He joined the team in 2013 with the Red, White, and Blue column covering the Home Nations before serving as Assistant Editor and News Editor from 2015. He specialises in the Union and constitutional issues as well as leading on education and housing stories.', 
          link: '/author/henry-hill/', 
          twitter: 'HCH_Hill', 
          image: 'https://conservativehome.com/wp-content/uploads/2022/06/henry-hill-square.jpg' 
        },
        { 
          name: 'Tali Fraser', 
          position: 'Assistant Editor', 
          text: 'Tali Fraser joined ConservativeHome as Assistant Editor in March 2025. Tali’s previous journalism experience includes roles at The House magazine, The Spectator and The Mail on Sunday.', 
          link: '/author/tali-fraser/', 
          twitter: 'talifraser', 
          image: 'https://conservativehome.com/wp-content/uploads/2025/04/tali.jpg' 
        },
        // { 
        //   name: 'William Atkinson', 
        //   position: 'Assistant Editor', 
        //   text: 'William Atkinson is ConservativeHome\'s Assistant Editor. He graduated from Oxford, where he studied History, in 2021. He then worked as a teacher in North London before joining ConservativeHome in March 2022.', 
        //   link: '/author/william-atkinson/', 
        //   twitter: 'WTMAtkinson', 
        //   image: 'https://conservativehome.com/wp-content/uploads/2022/06/william-atkinson-square.jpg' 
        // },
        { 
          name: 'Harry Phibbs', 
          position: 'Local Government Editor', 
          text: 'Harry Phibbs is the Local Government Editor of Conservative Home. He is a former councillor in Hammersmith and Fulham.', 
          link: '/author/harry-phibbs/', 
          twitter: 'harryph', 
          image: 'https://conservativehome.com/wp-content/uploads/2022/06/harry-phibbs-square.jpg'
        },
        { 
          name: 'Andrew Gimson', 
          position: 'Contributing Editor', 
          text: 'Andrew Gimson is Contributing Editor of ConservativeHome, author of Boris: The Making of the Prime Minister, and has also written Gimson\'s Kings & Queens, Gimson\'s Prime Ministers and Gimson\'s Presidents.', 
          link: '/author/andrew-gimson/', 
          twitter: 'AndrewGimson', 
          image: 'https://conservativehome.com/wp-content/uploads/2022/06/andrew-gimson-square.jpg' 
        },
        { 
          name: 'Sara Kumar', 
          position: 'Deputy Head of Events, Total Politics', 
          text: 'Sara Kumar joined ConservativeHome as Events Manager in 2022, before being promoted to Head of Events later that year. She is now Deputy Head of Events for Total Politics, organising and delivering events for ConservativeHome and our sister titles. She was a Conservative Parliamentary Candidate in the 2019 General Election and previously ran her own online business.', 
          link: false, 
          twitter: 'sarakumartweets', 
          image: 'https://conservativehome.com/wp-content/uploads/2022/06/sara-kumar-square.jpg' 
        },
        // { 
        //   name: 'Abigail Mainon', 
        //   position: 'Events Executive', 
        //   text: 'Abigail joined ConservativeHome in November 2022, having previously developed events management experience in a number of roles in the Welsh Parliament. She is a former Senedd candidate, and current Deputy Chair of the Welsh Conservatives.', 
        //   link: false, 
        //   twitter: 'AbigailMainon', 
        //   image: 'https://conservativehome.com/wp-content/uploads/2023/08/Abigail.jpeg' 
        // },
      ]
    })
  }
</script>
